import { watch } from 'vue';
import type { Ref } from 'vue';

/**
 * Composable for initializing sport selection based on available portal passes
 * @param sport - Reactive sport value reference
 * @param hasBaseballPass - If user has baseball portal pass
 * @param hasSoftballPass - If user has softball portal pass
 * @returns Functions to initialize and update sport
 */
export const useInitialSportSelection = (
  sport: Ref<string>,
  hasBaseballPass: Ref<boolean>,
  hasSoftballPass: Ref<boolean>
) => {
  // Initialize sport based on available portal passes
  const initializeSportBasedOnPasses = () => {
    // If they only have softball pass, use softball
    if (!hasBaseballPass.value && hasSoftballPass.value) {
      sport.value = 'Softball';
    }
    // If they only have baseball pass, use baseball
    if (hasBaseballPass.value && !hasSoftballPass.value) {
      sport.value = 'Baseball';
    }
    if (sport.value === '') {
      // if they have both passes, use baseball
      if (hasBaseballPass.value && hasSoftballPass.value) {
        sport.value = 'Baseball';
      } else if (hasBaseballPass.value) {
        // if they only have baseball pass, use baseball
        sport.value = 'Baseball';
      } else if (hasSoftballPass.value) {
        // if they only have softball pass, use softball
        sport.value = 'Softball';
      }
    }
  };

  // Watch for changes in portal pass status and update sport accordingly
  watch(
    [hasBaseballPass, hasSoftballPass],
    () => {
      initializeSportBasedOnPasses();
    },
    { immediate: true }
  );

  return {
    initializeSportBasedOnPasses
  };
};